import { useQuery } from '@apollo/client';
import { GetAppDetailsWithEditions } from '@atlassian/mpac-services-client';
export function useAppPlans(options, countryCode) {
  const {
    appId
  } = options;
  const {
    data,
    error,
    loading
  } = useQuery(GetAppDetailsWithEditions, {
    variables: {
      appId,
      countryCode
    }
  });
  return {
    data: (data === null || data === void 0 ? void 0 : data.marketplaceStoreAppWithEditions) || null,
    error,
    loading
  };
}